import React, { PureComponent } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Link } from 'formlabs-web-components/Link';

import './MenuList.module.css';

const MenuListSection = DisplayComponent(
  class MenuListSection extends PureComponent {
    render() {
      const { menuListItems, classes } = this.props;
      return (
        <div styleName="menu-list-section-wrapper" className={classes}>
          {menuListItems.map(item => {
            return (
              <Link to={item.url} key={`${item.url}${item.id}${item.name}`}>
                <div styleName="menu-list-section-item">
                  {item.text} <i className="fl-arrow-right" />
                </div>
              </Link>
            );
          })}
        </div>
      );
    }
  }
);

MenuListSection.propTypes = {};

export default MenuListSection;
